import { render } from "./IletsSlider.vue?vue&type=template&id=1986195a&scoped=true"
import script from "./IletsSlider.vue?vue&type=script&lang=js"
export * from "./IletsSlider.vue?vue&type=script&lang=js"

import "./IletsSlider.vue?vue&type=style&index=0&id=1986195a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1986195a"]])

export default __exports__